<template>
  <div class="instruction-page">
    <div class="instruction-page__content">
      <h2 class="greeting">Здравствуйте, {{ profile.first_name }}!</h2>
      <div class="instruction-page__text">
        <h2>
          О методике ТЭИ
        </h2>
        <p>
          Методика разработана под руководством доктора психологических наук, профессора ИП РАН Елены Алексеевны Сергиенко.
          Тест основан на теоретической модели эмоционального интеллекта как способности.
          Это означает, что эмоциональный интеллект рассматривается как измеряемая когнитивная способность, которую можно развивать.
        </p>
        <h2>Ваш результат</h2>
        <p>
          После обработки вы получите персональный профиль с оценкой ключевых способностей:
        </p>
        <ol>
          <li>Идентификация эмоций</li>
          <li>Использование эмоций в решении задач</li>
          <li>Понимание и анализ эмоций</li>
          <li>Сознательное управление эмоциями</li>
        </ol>
        <h2>Правила прохождения:</h2>
        <p>
          Чтобы результат был точным, просим соблюдать условия:
        </p>
        <div class="rules-cards">
          <a-card class="rules-card">
            <p class="mini-header semi-bold">
              🕒 Заложите 40 минут
            </p>
            <p>
              Выделите время. Тест нужно пройти за один раз, без пауз.
            </p>
          </a-card>

          <a-card class="rules-card">
            <p class="mini-header semi-bold">
              👤 Проходите тест самостоятельно
            </p>

            <p>
              Отвечайте самостоятельно и честно, не советуйтесь с другими людьми.
            </p>
          </a-card>

          <a-card class="rules-card">
            <p class="mini-header semi-bold">
              ⚡ Не размышляйте долго
            </p>

            <p>
              Отвечайте без долгих раздумий. Обычно первый пришедший в голову ответ — самый верный.
            </p>
          </a-card>

          <a-card class="rules-card">
            <p class="mini-header semi-bold">
              ➡️ Не выходите из экрана тестирования
            </p>

            <p>
              Постарайтесь не отвлекаться от теста. От этого зависят результаты вашего тестирования.
            </p>
          </a-card>
        </div>
      </div>
      <div class="instruction-page__btn flex justify-content-start">
        <a-button class="primary-button" @click="clickOnBtn">
          Начать тест
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import standartError from "@/mixins/standartError";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {reactive} from "@vue/reactivity";
import {computed, onBeforeMount, ref} from "@vue/runtime-core";


export default {
  name: "first-instruction",
  props: {
    title: {
      type: String,
      default: "Еще чуть-чуть и начнем!",
    },
    text: {
      type: String,
      default: "",
    },
    testInstruction: {
      type: Boolean,
      default: false,
    },
    requestSurvey: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, context) {

    const store = useStore(),
        route = useRoute(),
        router = useRouter();

    const profile = computed(() => store.state.profile.profile);

    const form = reactive({
      last_name: null,
      first_name: null,
      patronymic: null,
      age: null,
      sex: null,
      profession_id: null,
      industry_id: null,
      position_id: null,
      city: null,
      city_id: null,
    });

    const clickOnBtn = (event) => {
      // logic
      if (props.requestSurvey) {
        context.emit("clickOnBtn");
      } else {
        event.preventDefault();
        store.dispatch("test/sendTestForm", { code: route.params.code, form }).then(() => {
          context.emit("skipToQuestions");
        });
      }
    };

    const backClick = () => {
      context.emit("backClick");
    };

    return {
      form,
      clickOnBtn,
      backClick,
      profile,
    };
  },
};
</script>

<style scoped lang="scss">
.instruction-page {
  text-align: left;
  padding: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  word-break: break-word;

  &__content {

    h2 {
      font-size: 16px;
    }
    p {
      margin-bottom: 10px;
      font-size: 14px;
    }

    .greeting {
      font-size: 24px;
    }
  }

  &__text {
    margin-bottom: 25px;
    counter-reset: list;

    h2 {
      margin-top: 30px;
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 1em;
      letter-spacing: 0.01em;
    }

    ul li,
    ol li {
      font-size: 14px;
      position: relative;
      padding-left: 15px;
      margin-bottom: 5px;
      line-height: 1.3em;
    }
    ol {
      list-style: none;
    }

    ul li::before {
      position: absolute;
      content: "—";
      left: 0px;
    }

    ol li::before {
      position: absolute;
      counter-increment: list;
      content: counter(list) ".";
      left: 0;
    }
  }

  &__btn {
    button {
      margin-right: 10px;
    }
  }

  .btn {
    font-size: 14px;
  }

  @media (max-width: 1036px) {
    &__content {
      padding: 0 20px 20px 20px;
      h1 {
        font-size: 35px;
      }
      p {
        font-size: 14px;
      }
      ul li,
      ol li {
        font-size: 14px;
      }
    }
  }
}

.rules-cards {
  display: flex;
  flex-wrap: wrap;
  column-gap: 15px;
  row-gap: 8px;

  .rules-card {
    width: 47%;
  }

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    row-gap: 15px;

    .rules-card {
      width: 100%;
    }
  }
}
</style>
